import React from 'react';
import { useCommunicationSettingsState } from './CommunicationSettings.State';
import CommunicationSettingsView from './CommunicationSettings.View';

const CommunicationSettings: React.FC = () => {
    const state = useCommunicationSettingsState();

    return <CommunicationSettingsView {...state} />;
};

export default CommunicationSettings;
